module.exports = __webpack_public_path__ + "img/diamond.dc80ce4b.png";